import React from 'react';
import { FaUserCircle } from 'react-icons/fa';
import '../styles/Header.css';

const Header = () => {
  const userName = localStorage.getItem('userName') || 'Admin';

  const handleLogout = () => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    window.location.href = '/login';
  };

  return (
    <div className="header-container">
      <FaUserCircle className="profile-icon" />
      <span className="user-name">{userName}</span>
      <button className="logout-button" onClick={handleLogout}>
        Logout
      </button>
    </div>
  );
};

export default Header;
